import React, { useEffect, useState } from "react";
import { Grid, Icon, Menu, Segment } from "semantic-ui-react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useLocation, useNavigate, useParams } from "react-router";
import { NavLink } from "react-router-dom";

import userActions from "actions/user";
import ProfileHeader from "./ProfileHeader";
import { USER_PERMISSIONS } from "dyl-components";
import RestrictedView from "shared/RestrictedView";
import teamsActions from 'actions/teams';

import "./index.scss";

const Profile = ({ isReadingUser, user_id, isUserDataLoaded }) => {
    const navigate = useNavigate();
 
    const { id } = useParams();
    const { pathname } = useLocation();
    const end = pathname.split("/").pop();
    const root = id ? `/settings/users/${id}` : `/profile`;

    const preferencesTabs = [
        { menuItem: "Integration", path: "integration", userPermission: USER_PERMISSIONS.USER_PROFILE_PREFERENCES_VIEW },
        { menuItem: "Notifications", path: "notification", userPermission: USER_PERMISSIONS.USER_PROFILE_PREFERENCES_VIEW },
        { menuItem: "Phone", path: "phone", userPermission: USER_PERMISSIONS.USER_PROFILE_PREFERENCES_VIEW },
    ];

    const isPreferencesSubTabOpen = preferencesTabs.findIndex((tab) => tab.path === end) !== -1 || pathname.includes("integration");

    
    const PrefMenu = (
        <RestrictedView userPermission={USER_PERMISSIONS.USER_PROFILE_PREFERENCES_VIEW} type="disabled" userRestrict>
            <Menu.Item
                onClick={() => {
                    navigate(`${root}/integration`);
                }}
                key="Preferences"
            >
                Preferences
                {isPreferencesSubTabOpen && <Icon name="caret down" />}
            </Menu.Item>
        </RestrictedView>
    )

    const panes = [
        { menuItem: "General", path: "general", userPermission: USER_PERMISSIONS.USER_PROFILE_GENERAL_VIEW},
        { menuItem: "Team(s)", path: "teams", userPermission: USER_PERMISSIONS.USER_PROFILE_TEAMS_VIEW },
        { menuItem: PrefMenu, path: "integration", userPermission: USER_PERMISSIONS.USER_PROFILE_PREFERENCES_VIEW},
        ...(isPreferencesSubTabOpen ? preferencesTabs : []),
    ];

    return (
        <Segment.Group
            style={{
                marginLeft: "-1em",
                marginRight: "-1em",
                ...(id ? { border: "none", boxShadow: "none" } : {}),
            }}
        >
            <Segment basic={id} loading={isReadingUser}>
                {isUserDataLoaded && <ProfileHeader user_id={user_id} />}
            </Segment>
            <Segment basic={id}>
                <Grid>
                    <Grid.Column width={3}>
                        <Menu
                            className={`Tabs Tabs${
                                isPreferencesSubTabOpen
                                    ? "--preferencesTabOpen"
                                    : ""
                            }`}
                            secondary
                            fluid
                            vertical
                            color="blue"
                        >
                            {panes.map((pane) =>
                                typeof pane.menuItem === "string" ? (
                                    <RestrictedView userPermission={pane.userPermission} type="disabled" userRestrict>
                                        <Menu.Item
                                            key={pane.path}
                                            className={({ isActive }) =>
                                                isActive ? "active" : ""
                                            }
                                            as={NavLink}
                                            to={`${root}/${pane.path}`}
                                        >   
                                            {pane.menuItem}
                                        </Menu.Item>
                                    </RestrictedView>
                                ) : (  
                                    pane.menuItem
                                )
                            )}
                        </Menu>
                    </Grid.Column>
                    <Grid.Column width={13}>
                        <Segment loading={isReadingUser} basic>
                            {isUserDataLoaded ? <Outlet /> : <Segment loading basic />}
                        </Segment>
                    </Grid.Column>
                </Grid>
            </Segment>
        </Segment.Group>
    );
};

const ProfileContainer = (props) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { id } = useParams();

    const [isUserDataLoaded, setIsUserDataLoaded] = useState(false);

    const { pathname } = useLocation();
    const { isReadingUserProfile, user_id } = useSelector(state => ({
        isReadingUserProfile: state.user.isReadingUserProfile,
        user_id: state.auth.user_id,
    }));
    const record_id = Number(id);

    useEffect(() => {
        if((pathname?.split("/")[2] === "users")){
            dispatch(teamsActions.getUserTeams(user_id));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    
    useEffect(() => {
        dispatch(userActions.viewUserProfile(record_id)).then(() => {
            setIsUserDataLoaded(true);
        });
        dispatch(userActions.readLocations(record_id));
        dispatch(userActions.readProfileLogo({ thumbnail: true, user_id: record_id }));
    }, [navigate, pathname, record_id, dispatch]);

    useEffect(() => {
        if((pathname?.split("/")[2] === "users")){
            dispatch(teamsActions.getUserTeams(user_id));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <div>
            <Profile
                editable={props.editable}
                isReadingUser={isReadingUserProfile}
                showUploadModal={props.showUploadModal}
                user_id={record_id}
                isUserDataLoaded={isUserDataLoaded}
            />
        </div>
    );
};
export default ProfileContainer;
